import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const {reload} = props;
  const customerPortfolioB = props.model;
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zonas, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
    }
  }, [props.model]);


  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={reload}
        entity='sale/mecanica-detalle'
        dataForce={{
          max_coverage: dataChanging.max_coverage || 999,
        }}
      >
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={dataChanging.description || ''}
          required
        />
        <TextField
          label="Rango minimo"
          fullWidth
          type="number"
          name="min_coverage"
          margin="normal"
          defaultValue={dataChanging.min_coverage || ''}
          onKeyPress={onlyInteger}
          required
        />
        <TextField
          label="Rango maximo"
          fullWidth
          type="number"
          name="max_coverage"
          margin="normal"
          defaultValue={dataChanging.max_coverage || ''}
          onKeyPress={onlyInteger}
          required
        />
        <TextField
          label="Incentivo vendedor"
          fullWidth
          type="number"
          name="incentivo_vendedor"
          margin="normal"
          defaultValue={dataChanging.incentivo_vendedor || ''}
          // onKeyPress={onlyInteger}
        />
        <TextField
          label="Incentivo supervisor"
          fullWidth
          type="number"
          name="incentivo_supervisor"
          margin="normal"
          defaultValue={dataChanging.incentivo_supervisor || ''}
          // onKeyPress={onlyInteger}
        />
      </Modal>
    </>
  );
}
